"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.DescIcon = (0, react_1.forwardRef)(function DescIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.9306 15.999C8.79368 15.9989 8.65936 16.0363 8.54219 16.1072C8.42503 16.178 8.32948 16.2795 8.26591 16.4008C8.20235 16.5221 8.17319 16.6584 8.18159 16.7951C8.19 16.9317 8.23565 17.0635 8.3136 17.176L11.3826 21.608C11.4516 21.7077 11.5438 21.7891 11.6511 21.8453C11.7585 21.9015 11.8779 21.9309 11.9991 21.9309C12.1203 21.9309 12.2397 21.9015 12.3471 21.8453C12.4544 21.7891 12.5466 21.7077 12.6156 21.608L15.6846 17.176C15.7625 17.0635 15.8082 16.9317 15.8166 16.7951C15.825 16.6584 15.7958 16.5221 15.7323 16.4008C15.6687 16.2795 15.5732 16.178 15.456 16.1072C15.3388 16.0363 15.2045 15.9989 15.0676 15.999H13.0006V3.99902C13.0006 3.73381 12.8952 3.47945 12.7077 3.29192C12.5202 3.10438 12.2658 2.99902 12.0006 2.99902C11.7354 2.99902 11.481 3.10438 11.2935 3.29192C11.106 3.47945 11.0006 3.73381 11.0006 3.99902V15.999H8.9306Z", fill: "currentColor" })));
});
